import styled, { keyframes } from "styled-components";

export const DashboardContainer = styled.div`
  width: 100%;
  min-height: 100vh;
  overflow: hidden;
  background-image: url("textura.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  box-sizing: border-box;
  padding: 50px 30px 200px 30px;
  display: flex;
  flex-direction: column;

  @media (max-width: 1000px) {
    flex-direction: column;
    justify-content: center;
    padding: 40px 20px 100px 20px;
  }
`;

export const LoginBehind = styled.img`
  position: fixed;
  width: 350px;
  top: 30%;
  z-index: 1;
  left: 50%;
  opacity: 0.5;
  transform: translateX(-50%);
`;

export const PrincipalContent = styled.div`
  z-index: 2;
`;

export const ContainerTitle = styled.div`
  width: 100%;
  font-size: 28px;
  font-weight: 600;
  color: #000026;
  transition: 0.5s;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  p {
    margin: 0;
  }

  &:hover {
    padding: 0px 0px 0px 10px;
    color: #ffd100;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
  }

  @media (max-width: 1000px) {
    p {
      font-size: 28px;
    }
  }
`;

// export const SaldacoesUsuario = styled.div`
//   width: 100%;
//   margin-top: 20px;
//   margin-bottom: 30px;

//   span {
//     color: #000000;
//     text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
//     font-weight: 600;
//     font-size: 22px;
//   }

//   @media (max-width: 1000px) {
//     margin-top: 10px;
//     margin-bottom: 20px;

//     span {
//       font-size: 18px;
//     }
//   }
// `;

export const SaldacoesUsuario = styled.div`
  width: 100%;
  margin-top: 20px;
  margin-bottom: 30px;
  display: flex;
  align-items: center; /* Centraliza verticalmente no desktop */
  flex-wrap: wrap;

  span {
    color: #000000;
    text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.5);
    font-weight: 600;
    font-size: 22px;
  }

  @media (max-width: 1000px) {
    margin-top: 10px;
    margin-bottom: 20px;
    flex-direction: column;
    align-items: flex-start; /* Alinha o texto à esquerda no mobile */

    span {
      font-size: 18px;
    }
  }
`;

export const ReloadWeb = styled.div`
  width: 100%;
  display: flex;
  align-items: end;
  justify-content: end;
  box-sizing: border-box;
  padding-right: 20px;
  margin-top: 20px;

  span {
    cursor: pointer;
    font-weight: 500;
    transition: 0.3s;

    &:hover {
      color: rgba(0, 0, 0, 0.4);
    }
  }
`;

export const ContainerContent = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 800px) {
    flex-direction: column;
    gap: 20px;
  }
`;

/* --- MODIFICAÇÃO DE GRID --- */
export const BartIsTheBestFriend = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1.5fr 1fr;
  gap: 24px;

  @media (max-width: 1200px) {
    grid-template-columns: 1fr;
  }
`;

export const StatsGrid = styled.div`
  display: grid;
  gap: 20px;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto;

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

/* --- NOVOS ESTILOS DE STATCARD --- */

export const StatCard = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 16px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  overflow: hidden;
  border: 2px solid rgba(30, 30, 30, 0);

  .stat-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
  }

  &:hover {
    transform: translateY(-4px);
    border: 2px solid rgba(30, 30, 30, 0.3);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  }
`;

export const IconBox = styled.div`
  width: 54px;
  height: 54px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 22px;
  background: ${(props) => props.gradient || "#333"};
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  flex-shrink: 0;
`;

export const MainStatCard = styled.div`
  grid-column: 1 / -1;
  background: linear-gradient(135deg, #111827, #1f2937);
  color: white;
  border-radius: 16px;
  padding: 30px;
  display: flex;
  align-items: center;
  gap: 24px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  position: relative;
  overflow: hidden;
`;

export const MainIconBox = styled.div`
  font-size: 40px;
  color: #ffd700;
  background: rgba(255, 255, 255, 0.1);
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px rgba(255, 215, 0, 0.2);
`;

export const StatTitle = styled.h3`
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  color: #6b7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`;

export const StatTitleSub = styled.h3`
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #fbbf24;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 5px;
`;

export const StatValue = styled.p`
  margin: 0;
  font-size: 26px;
  font-weight: 600;
  color: rgba(80, 80, 80, 1);
  line-height: 1.1;

  @media (max-width: 1400px) {
    font-size: 18px;
  }
`;

export const MainStatValue = styled(StatValue)`
  font-size: 42px;
  color: #ffffff;
  font-weight: 900;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
`;

/* --- ESTILOS DA CAIXINHA GOLDEN --- */

const shimmerAnimation = keyframes`
    0% { background-position: -200% 0; }
    100% { background-position: 200% 0; }
`;

export const GoldenVaultCard = styled.div`
  position: relative;
  background: linear-gradient(135deg, #d4af37 0%, #f3d05b 50%, #b88a00 100%);
  border-radius: 16px;
  padding: 24px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 10px 25px rgba(212, 175, 55, 0.4);
  color: #3e2700;
  overflow: hidden;
  min-height: 300px;
  transition: transform 0.3s ease;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      105deg,
      transparent 20%,
      rgba(255, 255, 255, 0.4) 25%,
      rgba(255, 255, 255, 0.7) 30%,
      transparent 35%
    );
    background-size: 200% 100%;
    animation: ${shimmerAnimation} 5s infinite linear;
    pointer-events: none;
  }

  &:hover {
    transform: translateY(-6px);
    box-shadow: 0 15px 35px rgba(212, 175, 55, 0.6);
  }
`;

export const VaultHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 2;

  h3 {
    margin: 0 0 5px 0;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 1px;
    color: #2a1d00;
  }
`;

export const VaultIconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  padding: 5px;
  box-sizing: border-box;

  .loading-svg-container {
    transform: scale(0.4);
  }

  .loading-text {
    display: none;
  }
`;

export const VaultToggleContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-top: 5px;
`;

export const VaultToggleButton = styled.button`
  border: none;
  background: ${(props) =>
    props.active ? "#2a1d00" : "rgba(255,255,255,0.4)"};
  color: ${(props) => (props.active ? "#ffd700" : "#3e2700")};
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: ${(props) =>
    props.active ? "0 2px 5px rgba(0,0,0,0.2)" : "none"};

  &:hover {
    transform: scale(1.05);
    background: ${(props) =>
      props.active ? "#2a1d00" : "rgba(255,255,255,0.6)"};
  }
`;

export const VaultMainValue = styled.div`
  z-index: 2;
  margin: 20px 0;

  span {
    font-size: 14px;
    font-weight: 600;
    text-transform: uppercase;
    opacity: 0.8;
  }

  h1 {
    margin: 5px 0 0 0;
    font-size: 42px;
    font-weight: 900;
    color: #1a1100;
    text-shadow: 1px 1px 0px rgba(255, 255, 255, 0.2);
    line-height: 1;
  }
`;

export const VaultInfoGrid = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: auto;
  z-index: 2;

  .info-item {
    display: flex;
    flex-direction: column;

    small {
      font-size: 12px;
      font-weight: 600;
      opacity: 0.7;
    }
    strong {
      font-size: 16px;
      font-weight: 800;
    }
  }

  .right {
    text-align: right;
  }
`;

/* --- NOVO ESTILO: BANNER DE PUBLICIDADE --- */
export const AdvertisingBanner = styled.div`
  width: 100%;
  //   margin-top: 20px;
  background: linear-gradient(90deg, #111827 0%, #1f2937 100%);
  border-radius: 16px;
  padding: 20px 30px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
  border-left: 6px solid #ffd700; /* Detalhe Dourado na lateral */

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.3);
  }

  .content-side {
    display: flex;
    flex-direction: column;
    gap: 5px;

    h2 {
      margin: 0;
      font-size: 22px;
      font-weight: 800;
      color: #ffd700;
      letter-spacing: 1px;
      text-transform: uppercase;
    }

    p {
      margin: 0;
      font-size: 14px;
      color: #d1d5db;

      strong {
        color: white;
        font-weight: 700;
      }
    }
  }

  .action-side {
    button {
      background: white;
      color: #111827;
      border: none;
      padding: 10px 20px;
      border-radius: 30px;
      font-weight: 800;
      font-size: 12px;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;
      transition: all 0.3s ease;
      text-transform: uppercase;

      &:hover {
        background: #ffd700;
        transform: scale(1.05);
      }
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 15px;
    text-align: center;

    .action-side {
      width: 100%;
      button {
        width: 100%;
        justify-content: center;
      }
    }
  }
`;
/* ----------------------------------------- */

export const StatIcon = styled.div`
  display: none;
`;

export const ProgressBar = styled.div`
  position: absolute;
  bottom: 10px;
  left: 20px;
  right: 20px;
  height: 10px;
  background-color: #ffff;
  border: 1px solid rgba(0, 0, 0, 0.2);
  overflow: hidden;
  box-shadow: 3px 3px 2px rgba(0, 0, 0, 0.2);
`;

export const ProgressFill = styled.div`
  width: ${(props) => props.percentage}%;
  height: 100%;
  background-color: rgba(99, 253, 15, 0.8);
  transition: width 4s ease;
`;

export const PercentageCount = styled.div`
  position: absolute;
  bottom: 25px;
  left: 25px;
  color: white;
  cursor: pointer;
  width: 60px;
  text-align: center;
  border-radius: 20px;
  font-weight: 600;
  padding: 2px;
  background-color: rgba(99, 253, 15, 0.8);
  border: 1px solid rgba(0, 0, 0, 0.1);

  @media (max-width: 1000px) {
    width: 60px;
    font-size: 12px;
    color: black;
  }
`;

export const SecondRow = styled.div`
  width: 100%;
  height: max-content;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 40px;

  h1 {
    text-align: center;
    margin: 0;
    color: #000000;
    text-shadow: 1px 1px 5px rgba(0, 0, 0, 0.1);
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    margin-top: 20px;

    h1 {
      font-size: 18px;
      text-shadow: 1px 2px 1px rgba(0, 0, 0, 0.4);
    }
  }
`;

export const SaldoDisponivelParaSaque = styled.div`
  position: relative;

  @media (max-width: 1000px) {
    margin-top: 10px;
  }
`;

export const IndiqueEGanha = styled.div`
  width: 100%;
  padding: 20px;
  box-shadow: 2px 3px 6px rgba(0, 0, 0, 0.67);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;

  p {
    color: #3288be;
    margin: 0;
    text-align: center;
  }

  span {
    color: #31d0e3;
    cursor: pointer;

    &:hover {
      font-weight: 800;
    }
  }

  &:hover {
    p {
      color: #fff;
    }
    background-color: #3288be;
    transform: scale(1.03);
  }

  @media (max-width: 1000px) {
    background: linear-gradient(
      -60deg,
      #b17d2a,
      #b17d2a,
      #e6aa3a,
      #b17d2a,
      #b17d2a
    );

    p {
      color: #000000;
      font-weight: 500;
    }

    span {
      color: #ffffff;
      cursor: pointer;
    }
  }
`;

export const ThirdRow = styled.div`
  margin-top: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;

  @media (max-width: 1200px) {
    flex-direction: column;
  }

  h2 {
    margin: 0;
    font-size: 38px;
    color: rgba(80, 80, 80, 1);
  }
`;

export const TabelaContainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  overflow: auto;
  margin-bottom: 80px; /* 🔑 ADICIONADO: Espaço extra para não bater no botão da IA */
  padding-bottom: 10px; /* 🔑 ADICIONADO: Garante que a barra de rolagem não cole no conteúdo */

  /* Estilização da scrollbar para facilitar o arraste */
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d4af37;
    border-radius: 10px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.05);
  }
`;

export const GrapthContainer = styled.div`
  width: 100%;
  height: 450px;
  box-shadow: 3px 3px 4px rgba(0, 0, 0, 0.4);

  @media (max-width: 1000px) {
    height: 300px;
    width: 100%;
  }
`;

export const IndicadosContainer = styled.div`
  width: 100%;
  display: flex;
  padding: 80px 50px 50px 50px;
  box-sizing: border-box;
  flex-direciton: column;
  gap: 50px;
  max-height: 450px;
  overflow: auto;
  flex-direction: column;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.4);
  background: white;
  position: relative;

  @media (max-width: 1000px) {
    height: 300px;
    align-item: center;
    justify-content: center;
  }
`;

export const Indicado = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  .info {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    gap: 10px;

    img {
      width: 20px;
      height: 20px;
    }

    span {
      color: black;
      font-weight: 800;
      font-size: 18px;
    }

    h6 {
      margin: 0;
      font-size: 18px;
      color: red;
    }

    .ativo {
      color: green;
    }
  }

  @media (max-width: 1000px) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;

    .info {
      flex-direction: column;
      align-items: center;
      max-width: 200px;
      text-align: center;
    }
  }
`;

export const Justing = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const TableColumns = styled.div`
  width: 100%;
  position: absolute;
  height: 50px;
  display: flex;
  justify-content: space-between;
  padding: 15px 50px;
  box-sizing: border-box;
  top: 0;
  left: 0;
  border-bottom: 3px solid black;
  color: black;
  gap: 20px;

  span {
    font-weight: 800;
    font-size: 22px;
  }

  @media (max-width: 1000px) {
    .itemColumnName {
      display: none;
      border: 0;
      height: 0;
    }
  }
`;

export const WrapIt = styled.div`
  width: 100%;
  max-height: 450px;
  overflow: auto;
  box-shadow: 4px 4px 2px rgba(0, 0, 0, 0.4);
`;

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

  .spinner {
    color: white; /* Ou dourado #ffd700 */
    font-size: 24px;
    animation: ${spin} 1s linear infinite;
  }
`;

export const VaultLoadingState = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px; /* Altura aproximada do conteúdo */

  p {
    font-size: 16px;
    font-weight: 600;
    color: #3e2700;
    opacity: 0.7;
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 0.5;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: 0.5;
    }
  }
`;

export const VipInfoIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  cursor: pointer;
  color: #b88a00;
  font-size: 20px;
  /* Removido margens individuais para não quebrar o alinhamento do flex */

  &:hover {
    color: #000;
  }

  @media (max-width: 1000px) {
    font-size: 18px; /* Reduz um pouco no mobile para combinar com o badge */
  }
`;

export const VipContainer = styled.div`
  display: flex;
  align-items: center; /* Centraliza o selo e o ícone de informação perfeitamente */
  justify-content: center;
  margin-left: 15px;

  @media (max-width: 1000px) {
    margin-left: 0;
    margin-top: 10px; /* Margem aplicada ao grupo todo, não só ao badge */
  }
`;

// Overlay do Modal (Fundo escuro)
// Overlay: Adicionado overflow-y para telas muito pequenas
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  padding: 20px;
  box-sizing: border-box; /* Garante que o padding não expanda a div */
  backdrop-filter: blur(3px);
`;

// Conteúdo: Ajustado width e max-width com box-sizing
export const ModalContent = styled.div`
  background: white;
  padding: 40px 30px 30px 30px;
  border-radius: 16px;
  width: 100%; 
  max-width: 400px; /* Largura máxima para desktop */
  position: relative;
  box-sizing: border-box; /* ESSENCIAL para não vazar da tela */
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
  border-top: 6px solid #ffd700;
  text-align: center;
  
  /* Ajuste para celulares bem pequenos */
  @media (max-width: 400px) {
    padding: 35px 20px 25px 20px;
  }

  h3 {
    margin: 10px 0;
    color: #1a1100;
    font-size: 20px;
    font-weight: 800;
  }

  p {
    color: #4b5563;
    line-height: 1.5;
    font-size: 15px;
    margin: 0;
    
    strong {
      color: #b88a00;
    }
  }
`;

export const CloseModalButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: #f3f4f6;
  border: none;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #374151;
  transition: all 0.2s;

  &:hover {
    background: #e5e7eb;
    color: #ef4444;
  }
`;

export const VipBadge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: linear-gradient(135deg, #ffd700 0%, #f3d05b 50%, #b88a00 100%);
  color: #1a1100;
  padding: 5px 15px;
  border-radius: 50px;
  font-size: 14px;
  font-weight: 900;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 4px 10px rgba(212, 175, 55, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.3);

  svg {
    font-size: 16px;
  }

  @media (max-width: 1000px) {
    font-size: 12px;
    padding: 3px 10px;
  }
`;